module.exports = __webpack_public_path__ + "img/logo2x.43389fe8.png";